/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {selectSuperstackingPlan} from '../api'

export const useMutationSelectSuperstackingPlan = createReactQueryMutationHook('selectSuperstackingPlan', selectSuperstackingPlan)
